// extracted by css-extract-rspack-plugin
export default {"tabs":"ugwDWc"};